export default ({ isButtonVisible, paddingBottom }) => ({
  assistBtn: null,
  layoutFixed: null,
  footer: null,
  mainLayout: null,
  vv: null,
  isIphone: /iPhone/i.test(navigator.userAgent),

  init() {
    if (!this.isIphone) return

    window.addEventListener("pageshow", (event) => {
      // If page loaded from cache
      if (event.persisted && this.assistBtn) {
        // Temporarily disable transitions to prevent the "slide"
        this.assistBtn.classList.add('no-transition')
        this.resetState()
          
        // Re-enable transitions after the browser has reset the position
        setTimeout(() => {
          this.assistBtn.classList.remove('no-transition')
        }, 150)
      }
    })

    this.$nextTick(() => {
      this.vv = window.visualViewport
      // Broaden selection to ensure we catch all potential inputs
      this.assistBtn = document.querySelector("#js-assist-button")
      this.layoutFixed = document.querySelector("#pipe-layout-bottom-wrapper")
      this.mainLayout = document.querySelector(".pipe-layout")
      this.footer = document.querySelector("#footer")

      if (!this.vv || !this.assistBtn) return

      this.addSafeSpacing()

      document.addEventListener("input", (e) => {
        const inputEl = e.target.closest(".pipe-input")
        if (!inputEl || !isButtonVisible) return

        this.startSmartPolling()
      })

      document.addEventListener("focusin", (e) => {
        const inputEl = e.target.closest(".pipe-input")
        if (!inputEl || !isButtonVisible) return

        this.startSmartPolling()
      })

      document.addEventListener("focusout", () => {
        // Small delay to see if we are focusing another input (like tabbing from ft to in)
        setTimeout(() => {
          const activeEl = document.activeElement
          const isStillInInput = activeEl && activeEl.closest(".pipe-input")
          const isClickingAssist = activeEl?.id === "js-assist-button"

          if (!isStillInInput && !isClickingAssist) {
            this.resetState()
          }
        }, 150)
      })

      this.vv.addEventListener("resize", () => this.position())
      this.vv.addEventListener("scroll", () => this.position())
    })
  },

  // Polling frequently for 1s catches the "sliding" accessory bar
  startSmartPolling() {
    let start = performance.now()
    const poll = (now) => {
      this.position()
      if (now - start < 800) {
        requestAnimationFrame(poll)
      }
    }
    requestAnimationFrame(poll)
  },

  position() {
    if (!this.vv || !this.assistBtn) return

    const layoutHeight = window.innerHeight
    const visualHeight = this.vv.height
    const visualTop = this.vv.offsetTop
    const bottomOffset = layoutHeight - (visualHeight + visualTop)

    // Spacing from viewport bottom
    const buttonMargin = 24
    // Heuristic: treat <= 60px as keyboard closed
    const keyboardThreshold = 60

    // If the keyboard is considered closed (or gap too small),
    // reset the button to its default state
    if (bottomOffset <= keyboardThreshold) {
      this.resetState()

      return
    }

    // Ensure we never apply a negative bottom value
    const finalBottom = Math.max(bottomOffset, 0) + buttonMargin
    this.assistBtn.style.bottom = `${finalBottom}px`

    // Re-check for overlap with other UI elements
    this.checkCollision()
  },

  resetState() {
    if(!this.assistBtn || !this.assistBtn.classList.contains("visible")) return

    this.assistBtn.classList.remove("visible", "dodge")
    this.assistBtn.style.bottom = ''

    if (this.layoutFixed) this.layoutFixed.style = ''
  },

  showButton() {
    if(!this.assistBtn || this.assistBtn.classList.contains("visible")) return

    this.assistBtn.classList.add("visible")
    this.assistBtn.classList.remove("dodge")

    if (this.layoutFixed) this.layoutFixed.style.visibility = "hidden"
  },

  checkCollision() {
    if (!this.assistBtn || !this.mainLayout) return

    const btnRect = this.assistBtn.getBoundingClientRect()
    const blocker = this.footer ? this.footer.getBoundingClientRect().top : this.mainLayout.getBoundingClientRect().bottom
    const spacing = 115
    const isOverlapping = btnRect.bottom > (blocker - spacing)

    if (isOverlapping) {
      this.resetState()
    } else {
      this.showButton()
    }
  },

  addSafeSpacing() {
    const assistBtnWrapper = document.querySelector(".js-assistant-btn-wrapper")

    if (assistBtnWrapper) {
      assistBtnWrapper.style.paddingBottom = paddingBottom
    }
  }
})